module.exports = __webpack_public_path__ + "img/hotel-8.0bfb79fa.jpeg";